import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Observable } from 'rxjs';

import { IVR } from '@pwp-common';

import { IvrService } from '../../../../../services/call/ivr/ivr.service';
import {
  getObjAutocompleteFormControlBaseProviders,
  ObjAutocompleteFormControlBase,
} from '../../../../generic/abstract-classes/obj-autocomplete-form-control-base';

@UntilDestroy()
@Component({
  selector: 'app-ivr-autocomplete',
  standalone: true,
  templateUrl: './ivr-autocomplete.component.html',
  styleUrls: ['./ivr-autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AutoCompleteModule, CommonModule, FormsModule, MatIconModule, ReactiveFormsModule, TranslocoModule],
  providers: [...getObjAutocompleteFormControlBaseProviders(() => IvrAutocompleteComponent)],
})
export class IvrAutocompleteComponent extends ObjAutocompleteFormControlBase<any> implements OnInit {
  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    public ivrService: IvrService,
  ) {
    super(changeDetectorRef);
  }

  public defineAllOptions(): Observable<IVR[]> {
    return this.ivrService.getDocsArray();
  }
}
